
<template>
    <ListDetailLayout
		    :store="assetTransfersStore"
        index-route-name="admin.assets.transfers"
		    create-permissions="create:asset-transfers"
		    @on-paginate="(page) => useOnPaginate(page, refreshAssetTransfers, params)"
		    @on-search="(page) => useOnSearch(page, refreshAssetTransfers, params)"
    >

		<template #list>
			<li v-for="transfer in assetTransfersStore.getAssetTransfers" :key="transfer.id">
				<router-link :to="{ name: 'admin.assets.transfers.transfer', params: { transfer: transfer.id } }" v-slot="{isActive}">
					<div :class="[isActive ? 'border-primary-500 dark:bg-surface-600' : 'border-transparent hover:bg-surface-50 dark:hover:bg-surface-800', 'transition-colors border-l-4 flex items-center justify-between gap-x-6 py-5 pl-3 pr-4 bg-surface-0 dark:bg-surface-800']">

						<div class="min-w-0">
							<div class="flex items-start gap-x-3">
									<p class="text-sm font-semibold leading-6 text-surface-900 dark:text-surface-200">
										{{ transfer.asset?.name || ($t('common.transfer') + ' #' + transfer.id) }}
									</p>
							</div>

							<div class="mt-1 flex items-center gap-x-2 text-xs leading-5 text-surface-500 dark:text-surface-400">
								<p class="whitespace-nowrap">
									{{ (transfer.pre_owner?.name || $t('common.public')) + ' → ' + (transfer.current_owner?.name || $t('common.public')) }}
								</p>
							</div>
						</div>

					</div>
				</router-link>
			</li>
		</template>

        <template #detail>
            <router-view v-if="$route.params.transfer" @on-save="refreshAssetTransfers" @on-delete="refreshAssetTransfers"></router-view>
        </template>

    </ListDetailLayout>
</template>

<script>
import ListDetailLayout from "@/Layouts/ListDetailLayout.vue";
import Container from "@/Components/Container.vue";
import { mapStores } from "pinia";
import { useAssetTransfersStore } from "@/stores/assetTransfers.js";
import { useOnPaginate, useOnSearch } from "@/Composables/Pagination.js";

export default {
	name: "AssetTransfersIndex",
	data() {
		return {
			params: {
				include: 'asset,preOwner,currentOwner',
			}
		}
	},
	methods: {
		useOnSearch,
		useOnPaginate,
		refreshAssetTransfers(){
			return this.assetTransfersStore.indexAssetTransfers(this.params);
		}
	},
	components: {Container, ListDetailLayout},
	computed: {
		...mapStores(useAssetTransfersStore)
	},
	async mounted() {
		await this.refreshAssetTransfers();
	}
}
</script>
